import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BiLogoYoutube } from 'react-icons/bi';

import { YoutubePosition } from '../dashboard/knowledge-bases-create/types';

type Props = {
  item?: any;
  type?: YoutubePosition;
};

const convertYoutubeUrl = (code: string) => {
  return `https://www.youtube.com/embed/${code}?rel=0&fs=1&showinfo=0`;
};

const urlVideo: { name: string; url: string }[] = [
  {
    name: 'VIDEOBOT_MESSAGE',
    url: convertYoutubeUrl('qPl-2-sgsN0'),
  },
  {
    name: 'BOT_MESSAGE',
    url: convertYoutubeUrl('_Bug_3u-SHs'),
  },
  {
    name: 'READ_USER_MESSAGE',
    url: convertYoutubeUrl('21yIWjiUAmA'),
  },
  {
    name: 'ADD_BUTTON',
    url: convertYoutubeUrl('yWmzlmEA1kQ'),
  },
  {
    name: 'ADD_LINK',
    url: convertYoutubeUrl('2UznkHXiJfk'),
  },
  {
    name: 'ASSIGN_VARIABLE',
    url: convertYoutubeUrl('UVKGnpU7gq0'),
  },
  {
    name: 'HTTP_REQUEST',
    url: convertYoutubeUrl('NCkG2pg1Bp4'),
  },
  {
    name: 'NOTIFY_ME_BY_EMAIL',
    url: convertYoutubeUrl('FC0lmCq1Y5c'),
  },
  {
    name: 'RECEIVE_ATTACHMENT',
    url: convertYoutubeUrl('kcIeS71UdoM'),
  },
  {
    name: 'CONDITIONS',
    url: convertYoutubeUrl('UdCs1MXngpc'),
  },
  {
    name: 'OVERRIDE_VARIABLE',
    url: convertYoutubeUrl('uhnK5MayVkk'),
  },
  {
    name: 'CREATE_VARIABLE',
    url: convertYoutubeUrl('uhnK5MayVkk'),
  },
  {
    name: 'SEND_MEDIA',
    url: convertYoutubeUrl('A9gmpr1HsJE'),
  },
  {
    name: 'SEND_ATTACHMENT',
    url: convertYoutubeUrl('Z1FZvbWj2R0'),
  },
  {
    name: 'LEAD_FORM',
    url: convertYoutubeUrl('d96qQ53t4Bw'),
  },
  {
    name: 'END_OF_CONVERSATION',
    url: convertYoutubeUrl('aGXEdCacJaY'),
  },
  {
    name: 'DELAY',
    url: convertYoutubeUrl('UKG1GdeJTX0'),
  },
  {
    name: 'GO_TO',
    url: convertYoutubeUrl('mYWxJWAPcVE'),
  },
  {
    name: 'MAKE_WEBHOOK',
    url: convertYoutubeUrl('xrq-U0nGZjE'),
  },
  {
    name: 'SWITCH_TO_CHATBOT',
    url: convertYoutubeUrl('KnuRIVmbUa4'),
  },
  {
    name: 'SUPER_USER_MANAGER_SERVICES',
    url: convertYoutubeUrl('94ds9gOeGNs'),
  },
  {
    name: 'PASS_TO_AI',
    url: convertYoutubeUrl('VHAYoLhaf_4'),
  },
  {
    name: 'SUMMARIZE_CONVERSATION',
    url: convertYoutubeUrl('t8QNnoW0ZGc'),
  },
  {
    name: 'ASK_TO_AI',
    url: convertYoutubeUrl('O2sgLCvSC1E'),
  },
  {
    name: 'JS_CODE',
    url: convertYoutubeUrl('5igpRr5m1Zo'),
  },
  {
    name: 'SPEECH_RECORDING',
    url: convertYoutubeUrl('04Lg7snmauI'),
  },
  {
    name: 'CHECK_IF_USER_EXISTS',
    url: convertYoutubeUrl('94ds9gOeGNs'),
  },
  {
    name: 'USER_CREDENTIAL',
    url: convertYoutubeUrl('94ds9gOeGNs'),
  },
  {
    name: 'GET_USER_INFO',
    url: convertYoutubeUrl('94ds9gOeGNs'),
  },
  {
    name: 'REGISTER_USER',
    url: convertYoutubeUrl('94ds9gOeGNs'),
  },
];

function ScenarioYoutubeVideo({ item, type = YoutubePosition.Other }: Props) {
  const [isVideo, setIsVideo] = useState(false);
  const [show, setShow] = useState(false);
  const [url, setUrl] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const find = urlVideo.find((dr: any) => dr.name == item.name);
    if (item && find) {
      setIsVideo(true);
      setUrl(find.url);
    }
  }, [item]);

  return (
    <React.Fragment>
      {isVideo &&
        (type == YoutubePosition.ScenarioHeader ? (
          <button
            id="btn-youtube-video-close-title"
            type="button"
            onClick={() => {
              setShow(true);
            }}
            className="tw-bg-white tw-h-10 tw-rounded-md tw-shadow-sm tw-border tw-border-gray-300 tw-justify-center tw-items-center tw-gap-1 tw-border-solid tw-flex "
          >
            <BiLogoYoutube size={24} className="tw-text-red-500" />
            <div className="tw-hidden sm:tw-block tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
              {t('BotTypedVideoTutorial/tutorial')}
            </div>
          </button>
        ) : (
          <button
            id="btn-youtube-video-close"
            type="button"
            onClick={() => {
              setShow(true);
            }}
            className="tw-border-none tw-bg-transparent  tw-h-full tw-z-999"
          >
            <BiLogoYoutube size={50} className="tw-text-red-500" />
          </button>
        ))}

      <Modal size="lg" show={show} onHide={() => setShow(false)} centered style={{ maxWidth: '100%' }}>
        <Modal.Header closeButton className="tw-border-0 tw-items-start">
          <span className="tw-text-zinc-900 tw-text-xl tw-font-bold tw-font-['Sofia Sans'] tw-items-start tw-justify-between">
            {t('BotTypedVideoTutorial/tutorial')}
          </span>
        </Modal.Header>
        <Modal.Body>
          <iframe src={url} width="100%" className="md:tw-h-[28rem] sm:tw-h-full" style={{ border: 'none' }} title="Tutorial Iframe"></iframe>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default ScenarioYoutubeVideo;
